import { forwardRef } from "react";
import { Link as RRLink, NavLink as RRNavLink, useLocation } from "react-router-dom";

/* Keeps shoppers inside /fr when they are browsing in French. */
export const isFrPath = (p) => p === "/fr" || p.startsWith("/fr/");
export const stripFr = (p) => (isFrPath(p) ? p.slice(3) || "/" : p);
export const withLang = (to, fr) => (typeof to === "string" && to.startsWith("/") && fr && !isFrPath(to) ? `/fr${to === "/" ? "" : to}` : to);

export const Link = forwardRef(({ to, ...rest }, ref) => {
  const { pathname } = useLocation();
  return <RRLink ref={ref} to={withLang(to, isFrPath(pathname))} {...rest} />;
});

export const NavLink = forwardRef(({ to, ...rest }, ref) => {
  const { pathname } = useLocation();
  return <RRNavLink ref={ref} to={withLang(to, isFrPath(pathname))} {...rest} />;
});
